(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipshop-wheelio-trigger"] && !Shopify.designMode) return;
  try {
    (() => {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: 'Asia/Jerusalem', year: 'numeric', month: '2-digit' }).formatToParts(new Date());
    const active = parts.find(part => part.type === 'year')?.value === '2026' && parts.find(part => part.type === 'month')?.value === '10';
    const update = () => {
      const nativeButton = document.getElementById('wlo-trigger-button');
      const label = document.querySelector('[data-shipshop-native-wheel-label]')?.getAttribute('data-shipshop-native-wheel-label');
      document.querySelectorAll('button[data-shipshop-wheelio-open]').forEach(button => { button.hidden = !active || !nativeButton; button.disabled = !nativeButton; });
      if (!nativeButton) return;
      nativeButton.parentElement.hidden = !active;
      const buttonLabel = label || '🎀 لفّي واربحي';
      let visibleLabel = nativeButton.querySelector('.shipshop-wheel-label');
      if (!visibleLabel) {
        visibleLabel = document.createElement('span');
        visibleLabel.className = 'shipshop-wheel-label';
        nativeButton.append(visibleLabel);
      }
      if (visibleLabel.textContent !== buttonLabel) visibleLabel.textContent = buttonLabel;
      nativeButton.setAttribute('data-shipshop-wheel-label', buttonLabel);
      nativeButton.setAttribute('aria-label', buttonLabel);
      nativeButton.setAttribute('aria-haspopup', 'dialog');
      nativeButton.setAttribute('role', 'button');
      nativeButton.setAttribute('dir', 'rtl');
      nativeButton.setAttribute('lang', 'ar');
      nativeButton.tabIndex = 0;
      if (!nativeButton.hasAttribute('data-shipshop-keyboard-ready')) {
        nativeButton.setAttribute('data-shipshop-keyboard-ready', '');
        nativeButton.addEventListener('keydown', event => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); nativeButton.click(); } });
      }
    };
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element) || !event.target.closest('button[data-shipshop-wheelio-open]')) return;
      const nativeButton = document.getElementById('wlo-trigger-button');
      if (!active || !nativeButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      nativeButton.click();
    }, true);
    const start = () => { update(); new MutationObserver(update).observe(document.body, { childList: true, subtree: true }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
    document.addEventListener('shopify:section:load', update);
  })();
  } catch(e) { console.error(e); }
})();

})();
